import BaseStore from './BaseStore';

import * as Instruments from '../models/instruments/all';
import * as Effects from '../models/effects/all';

class NavigationStore extends BaseStore {
	initialize() {
		this.tabs = {
			instruments: {
				name: 'Inst.',
				items: Object.entries(Instruments).map(function([type, instrument]){
					return {
						name: instrument.nice_name,
                        type
					};
				}),
				className: 'instruments'
			},
			effects: {
				name: 'FX',
				items: Object.entries(Effects).map(function([type, effect]){
					return {
						name: effect.nice_name,
                        type
					};
				}),
				className: 'effects'
			},
			midi: {
				name: 'MIDI',
				items: [],
				className: 'midi'
			}
		};
		this.selected = this.tabs['instruments'];
	}

	rehydrate(state) {

	}

	dehydrate() {
		return {};
	}

	getSelected() {
		return this.selected;
	}

	getTabInfo() {
		return Object.values(this.tabs).map(function(tab) {
			return {
				name: tab.name,
				className: tab.className
			}
		})
	}

	handleChangeTab(payload) {
		this.selected = this.tabs[payload.name];
		this.emit('NAVIGATION_SELECTED_TAB_CHANGE');
	}

	handleUsersReceiveSongs(payload) {
		this.tabs.songs.items = payload.songs;
		this.emit('NAVIGATION_SELECTED_TAB_CHANGE');
	}

	handleNewUserSong(payload) {
		this.tabs.songs.items.push(payload);
		this.emit('NAVIGATION_SELECTED_TAB_CHANGE');
	}

	handleUpdateUserSongName(payload) {
		for(var i = this.tabs.songs.items.length - 1; i >= 0; i--) {
			if(payload.id == this.tabs.songs.items[i].id) {
				this.tabs.songs.items[i].name = payload.name;
				break;
			}
		}
		this.emit('NAVIGATION_SELECTED_TAB_CHANGE');
	}

	handleUserDeletedSong(payload) {
		this.tabs.songs.items = this.tabs.songs.items.filter(function(song) {
			return song.id !== payload.id
		});
		this.emit('NAVIGATION_SELECTED_TAB_CHANGE');
	}

}

NavigationStore.storeName = "NavigationStore";
NavigationStore.handlers = {
	'NAVIGATION_CHANGE_TAB': 'handleChangeTab',
	'RECEIVE_USER_SONGS': 'handleUsersReceiveSongs',
	'ADD_USER_SONG': 'handleNewUserSong',
	'UPDATE_USER_SONG': 'handleUpdateUserSongName',
	'SONG_DELETED': 'handleUserDeletedSong'
};

export default NavigationStore;
